<template>
  <div class="roleselect-wrapper" v-if="user.data.roles.length">
    <div v-if="user.data.roles.length <= 1">
      <span class="profile__name">{{ user.data.selectedRole.name }}</span>
    </div>
    <div class="roleselect-container" v-else>
      <div class="dropdown">
        <button class="dropdown__button">
          <span><img class="role_icon" :src="defineRoleIcon(user.data.selectedRole.role)">{{ user.data.selectedRole.name
            }}</span>
          <span class="dropdown__icon" v-if="user.data.selectedRole.role !== 'user'">{{ $t('common.' +
    user.data.selectedRole.role) }}</span>
          <i class="icon-arrow-down"></i>
        </button>
        <div class="dropdown__content">
          <template v-for="partner in orderedRoles">
            <a :key="partner.id" class="dropdown__link" v-on:click.prevent="switchRole(partner)"
              v-if="partner.id !== user.data.selectedRole.id || partner.role !== user.data.selectedRole.role">
              <img class="role_icon" :src="defineRoleIcon(partner.role)">
              <span class="dropdown__icon" v-if="partner.role !== 'user'">{{ $t('common.' + partner.role) }}</span>
              <span>{{ partner.name }}</span>
            </a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      user: 'user/user/user',
    }),
    orderedRoles() {
      const r = [].concat(this.user.data.roles);
      return r.sort((a, b) => {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
  },
  methods: {
    switchRole(partner) {
      this.$store.dispatch('user/user/switchRole', partner).then(() => {
        this.$router.push({ name: 'dashboard' });
        history.go(0);
      });
    },
    defineRoleIcon(role) {
      switch (role) {
        case 'tenant':
          return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADTSURBVHgBxZPRDcIwDERPqAN0BG8AI3QENoANGCEjwAZlA8QEHaEjtExQNoB8OCiNbDcEoZ50P7H93DZXYAWR98Am/Kgdg17sgc+KdPCeIljwxLWvdBJAqV0uzGXAsqGtMth535TaWQLVPCQNNFFfYyysQxNhfpOxe2F5r/R+YqXBQlMqs38DW4T5h3fIDDcZrxKyNxn1jhl1xcDR+yksunrfk9oRcrDH9CC95Ra6LsITYglo/bOkAStjaG9At9qQBXQoUBybB8o1SocEOzpLkfmP3qbLjgNbdStwAAAAAElFTkSuQmCC'
        case 'landlord':
          return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADhSURBVHgB1ZTvDYIwEMWfxgF0AzbQERgBJxBHcAQnUCdgBZ0AnUA2gA1wg3oN19A/1rbGD/qSX3pQ+mjvDoB/0YEQEbTEPMZQJFC+M5riy9INH8SEWBNXjrfEheNThJ9jqEaVJzkKjgUiNNPizFrki6N3mCrZGT2Gyq/sScGTUgVRc1wSZ46PGKtcwm0nZ4cpOcxhKmM+zmFDbLTrjjEWpDa2SsEdnhzG0L84riFflWUhFhgaW9eOWLKx/bIK2nduT+aaScv3aox59lGl9OENgR8DqVCGe4Qlj9MFnmnw83oCYWZqm2lgXUQAAAAASUVORK5CYII='
        default:
          return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAYAAABSO15qAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACwSURBVHgBpZMBDQIxDEU/pwAJQwGggEnAAThBAhLAARKGBBwcDu4cQH9oyGVZ1l3vJ+/SXNqfttuAsnZCEgbho3FAo6IWlYgtBn3FoLeKY6W42EWXGQTYCjWDN2yZOYt2QEXMOIXpCBfhIRyEjfDU/6PGe2GL350450bXQqtM4oUKGqcs59bSsnmkHOEEv46dtukV9/V/MB6GlQZucYQRC0SDF/y687PWYM4umJtY+wXLRmoNpBHqngAAAABJRU5ErkJggg=='
      }
    },
  },
};

</script>

<style lang="scss">
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';
@import '~styles/icons.scss';
@import '~styles/_animations';

.role_icon {
  width: 20px;
  height: 20px;
  vertical-align: bottom;
  margin-right: 12px;
}

.roleselect-wrapper {
  width: 100%;
}

.dropdown__button {
  background-color: #BFE4FF;
}

.dropdown__link:hover {
  background-color: #1EE8CA;
}

.roleselect-container {
  display: flex;
  /*min-width: 300px;*/

  @media screen and (max-width: 775px) {
    width: 100%;
  }

  .dropdown {
    position: relative;
    display: inline-block;
    text-align: left;
    height: 46px;
    width: 100%;

    /*@media screen and (max-width: 775px) {
        width: 100px;
      }*/

    &:hover {
      transition: all 300ms ease-in-out;
      @include shadow(2);

      .dropdown__content {
        transition: all 300ms ease-in-out;
        visibility: visible;
        opacity: 1;
      }

      .icon-arrow-down {
        transform: rotate(180deg);
        transition: all 225ms ease-in-out;
      }
    }

    &__button {
      transition: all 300ms ease-in-out;
      background-color: #BFE4FF;
      padding: 0 10px 0 10px;
      border: none;
      cursor: pointer;
      text-align: center;
      height: 100%;
      width: 100%;
      font-weight: 400;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .icon-arrow-down {
        transition: all 225ms ease-in-out;
      }

      span {

        @media screen and (max-width: 450px) {
          font-size: 12.5px;
        }

      }

    }

    &__content {
      transition: all 100ms ease-in-out;
      @include shadow(2);
      opacity: 0;
      visibility: hidden;
      position: absolute;
      background-color: var(--grey-six);
      z-index: 1;
      min-width: 300px;
      width: 100%;
    }

    &__link {
      border-bottom: solid 1px var(--grey-five);
      color: black;
      padding: 12px 13px;
      text-decoration: none;
      display: block;
      text-align: left;
      border: 1px solid var(--grey-four);
      font-size: 13px;

      &:hover {
        background-color: #1EE8CA;
        border: 1px solid #1EE8CA;
        color: var(--white);
        transition: all 225ms ease-in-out;
      }
    }

    &__icon {
      float: right;
      text-transform: uppercase;
      font-size: 10px;

      @media screen and (max-width: 612px) {
        display: none;
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/RoleSelect.vue